import { configureStore } from "@reduxjs/toolkit";
import hireChefSlice from "./hireChefSlice";

export const store = configureStore({
  reducer: {
    chefSlice: hireChefSlice,
  },
});
